import {
  PublicoEnvioNotificacao,
  StatusNotificacao,
} from "@/services/central-notificacao.service";
import { TipoPlano } from "@/services/consultores.service";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { words } from "lodash";

export function moeda(value: number) {
  const formattedValue = new Intl.NumberFormat("pt-br", {
    style: "currency",
    currency: "BRL",
  }).format(value);

  return formattedValue;
}

export function dateYear(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("YYYY");
  return formattedValue;
}

export function dateDay(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("DD");
  return formattedValue;
}

export function dateMonth(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("MM");
  return formattedValue;
}

export function dateNameMonth(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("MMM");
  return formattedValue;
}

export function dateFullNameMonth(data?: string | null) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("MMMM");
  return formattedValue;
}

export function dateYearMonth(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("YYYY-MM");
  return formattedValue;
}

export function date(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("DD/MM/YYYY");
  return formattedValue;
}

export function dateFormatterSemHoras(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("DD/MM/YYYY");
  return formattedValue;
}

export function dateHoraMinuto(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("HH:mm");
  return formattedValue;
}

export function dateTime(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("DD/MM/YYYY HH:mm");
  return formattedValue;
}

export function dateTimeSeconds(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data);
  const formattedValue = objData.format("DD/MM/YYYY HH:mm:ss");
  return formattedValue;
}

export function dateTimeSecondsFormatIso(data: string) {
  if (!data) {
    return "";
  }
  const objData = dayjs(data, "YYYY-MM-DDTHH:mm:ss");
  const formattedValue = objData.format("DD/MM/YYYY HH:mm:ss");
  return formattedValue;
}

export function cpf(value: string | number) {
  const cpf = ("00000000000" + value).slice(-11);
  return cpf
    .toString()
    .replace(/(\d{3})?(\d{3})?(\d{3})?(\d{2})/, "$1.$2.$3-$4");
}

export function timeFromNow(data: string) {
  if (!data) {
    return "";
  }
  dayjs.extend(relativeTime);
  return dayjs(data).fromNow();
}
export function telefone(telefone: string) {
  if (!telefone) {
    return "";
  }
  if (telefone.toString().length == 10) {
    return telefone.toString().replace(/(\d{2})?(\d{4})?(\d{4})/, "($1) $2-$3");
  } else {
    return telefone.toString().replace(/(\d{2})?(\d{5})?(\d{4})/, "($1) $2-$3");
  }
}

export function highlight(
  value: string,
  search: string,
  highlightClass?: string,
) {
  if (!search) {
    return value;
  }

  const replaceString = highlightClass
    ? `$1<span class="${highlightClass}">$2</span>$3`
    : "$1<strong>$2</strong>$3";

  const valueWords = words(search);
  let strRet = value;
  valueWords.forEach((word: string) => {
    strRet = strRet.replace(
      new RegExp(`(.*)(${word})(.*)`, "ig"),
      replaceString,
    );
  });

  return strRet;
}

export function tipoPlano(idTipoPlano: TipoPlano | number): string {
  if (!idTipoPlano) {
    return "";
  }

  const numberToTipoPlanoMap: { [key: number]: string } = {
    1: "Grátis",
    2: "Mensal - Lite",
    3: "Trimestral - Lite",
    5: "Semestral - Lite",
    6: "Anual - Lite",
    7: "Bônus - Lite",
    8: "Mensal - Essencial",
    9: "Trimestral - Essencial",
    10: "Semestral - Essencial",
    11: "Anual - Essencial",
    12: "Bônus - Essencial",
    13: "Mensal - Essencial Conectada",
    14: "Trimestral - Essencial Conectada",
    15: "Semestral - Essencial Conectada",
    16: "Anual - Essencial Conectada",
    17: "Bônus - Essencial Conectada",
    18: "Mensal - Super Conectada",
    19: "Trimestral - Super Conectada",
    20: "Semestral - Super Conectada",
    21: "Anual - Super Conectada",
    22: "Bônus - Super Conectada",
    23: "Mensal - Hiper Conectada",
    24: "Trimestral - Hiper Conectada",
    25: "Semestral - Hiper Conectada",
    26: "Anual - Hiper Conectada",
    27: "Bônus - Hiper Conectada",
  };

  const tipoPlanoMap = {
    [TipoPlano.Gratis]: "Grátis",
    [TipoPlano.MensalLite]: "Mensal - Lite",
    [TipoPlano.TrimestralLite]: "Trimestral - Lite",
    [TipoPlano.SemestralLite]: "Semestral - Lite",
    [TipoPlano.AnualLite]: "Anual - Lite",
    [TipoPlano.BonusLite]: "Bônus - Lite",
    [TipoPlano.Mensal]: "Mensal - Essencial",
    [TipoPlano.Trimestral]: "Trimestral - Essencial",
    [TipoPlano.Semestral]: "Semestral - Essencial",
    [TipoPlano.Anual]: "Anual - Essencial",
    [TipoPlano.Bonus]: "Bônus - Essencial",
    [TipoPlano.MensalEssencialConectada]: "Mensal - Essencial Conectada",
    [TipoPlano.TrimestralEssencialConectada]:
      "Trimestral - Essencial Conectada",
    [TipoPlano.SemestralEssencialConectada]: "Semestral - Essencial Conectada",
    [TipoPlano.AnualEssencialConectada]: "Anual - Essencial Conectada",
    [TipoPlano.BonusEssencialConectada]: "Bônus - Essencial Conectada",
    [TipoPlano.MensalSuperConectada]: "Mensal - Super Conectada",
    [TipoPlano.TrimestralSuperConectada]: "Trimestral - Super Conectada",
    [TipoPlano.SemestralSuperConectada]: "Semestral - Super Conectada",
    [TipoPlano.AnualSuperConectada]: "Anual - Super Conectada",
    [TipoPlano.BonusSuperConectada]: "Bônus - Super Conectada",
    [TipoPlano.MensalHiperConectada]: "Mensal - Hiper Conectada",
    [TipoPlano.TrimestralHiperConectada]: "Trimestral - Hiper Conectada",
    [TipoPlano.SemestralHiperConectada]: "Semestral - Hiper Conectada",
    [TipoPlano.AnualHiperConectada]: "Anual - Hiper Conectada",
    [TipoPlano.BonusHiperConectada]: "Bônus - Hiper Conectada",
  };

  if (typeof idTipoPlano === "number") {
    return numberToTipoPlanoMap[idTipoPlano] || "";
  }

  return tipoPlanoMap[idTipoPlano] || "";
}

export function statusNotificacao(status: StatusNotificacao) {
  if (!status) {
    return "";
  }

  const statusMap = {
    [StatusNotificacao.Novo]: "Novo",
    [StatusNotificacao.Agendado]: "Agendado",
    [StatusNotificacao.Enviado]: "Enviado",
    [StatusNotificacao.Enviando]: "Enviando",
    [StatusNotificacao.Erro]: "Erro",
  };

  return statusMap[status] || "";
}

export function publicoNotificacao(publico: PublicoEnvioNotificacao) {
  if (!publico) {
    return "Todos os planos";
  }

  const publicoMap = {
    [PublicoEnvioNotificacao.Gratis]: "Grátis",
    [PublicoEnvioNotificacao.Lite]: "Lite",
    [PublicoEnvioNotificacao.Essencial]: "Essencial",
    [PublicoEnvioNotificacao.EssencialConectada]: "Essencial Conectada",
    [PublicoEnvioNotificacao.SuperConectada]: "Super Conectada",
    [PublicoEnvioNotificacao.HiperConectada]: "Hiper Conectada",
  };

  return publicoMap[publico] || "";
}

export function substring(value: string, length: number) {
  if (!value) {
    return "";
  }

  if (value.length <= length) {
    return value;
  }

  return value.substring(0, length) + "...";
}
